<!-- =========================================================================================
File Name: RegisterJWT.vue
Description: Register Page for JWT
----------------------------------------------------------------------------------------
Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
Author URL: http://www.themeforest.net/user/pixinvent 
========================================================================================== -->


<template>
  <div class="clearfix register_page mt-4">
    <vs-popup class="holamundo register_popup" title="Notification" :active.sync="popupActive">
      <h2>
        Welcome to All Doors!
      </h2>
      <p>
        Your account has been activated and you can start using the service immediately.
        More information about your account and company has been sent to your email.
        For any inquiries, feel free to contact us at<button class="link-text" @click.prevent="handleLinkClick">
          support@alldoors.online </button>.
        Please use this <button class="link-text" @click.prevent="handleLinkClick">link</button>to log in.
        Use the email specified during registration as login and enter your password.
        Regards,
      <h4>
        The AllDoors Online Team
      </h4>
      <h4>
        Notification
      </h4>
      </p>
    </vs-popup>


    <!-- <vs-popup class="holamundo register_popup" title="Notification" :active.sync="popupActive">
      <h2>
        We send invitation link to your email. Please open link and follow
        instruction for finish.
      </h2>

      <div class="send_again">
        Don't get an email?<vs-button @click="sendMailAgain" class="unimacs_button">Send Again</vs-button>
      </div>
    </vs-popup> -->

    <!-- <div class="vx-row w-full">
      <div class="vx-col w-full">
        <div class="vx-col w-full register_text" v-if="packet_type">
          {{ description }}
        </div>
      </div>
    </div> -->

    <div class="w-1/2 padding-r">
      <vs-input v-validate="'required|alpha_dash|min:3'" data-vv-validate-on="change" label="First Name*"
        name="first_name" placeholder="First Name" v-model="first_name" class="w-full" />
      <span class="text-danger text-sm" v-show="errors.has('first_name')">{{ errors.first("first_name") }}</span>
    </div>

    <div class="w-1/2 padding-l">
      <vs-input v-validate="'required|alpha_dash|min:3'" data-vv-validate-on="change" label="Last Name*"
        name="last_name" placeholder="Last Name" v-model="last_name" class="w-full" />
      <span class="text-danger text-sm" v-show="errors.has('last_name')">{{ errors.first("last_name") }}</span>
    </div>

    <div class="w-1/2 padding-r">
      <vs-input v-validate="'required|email'" data-vv-validate-on="change" name="email" type="email" label="Email*"
        placeholder="Email" v-model="email" class="w-full mt-6" />
      <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first("email") }}</span>
    </div>


    <div class="w-1/2 padding-l mt-6 pass_block">
      <vs-input type="password" @input="checkPassword(password)" name="Password" label="Password*"
        placeholder="Password" v-model="password" class="w-full reg_pass_inp" />
      <div class="pass_strength">

        <div class="reqments">
          To protect your data, you must create a secure password. It must contain
        </div>
        <div class="req_list">
          <ul>
            <li :class="{ success: !testMin }">Min 7 character</li>
            <li :class="{ success: !testNum }">Number</li>
            <li :class="{ success: !testUpper }">Upper case</li>
            <li :class="{ success: !lowerCase }"> Lower case</li>

            <!-- <li>dfsafsdf</li> -->
          </ul>
        </div>

      </div>
      <span class="text-danger text-sm">{{ errors.first("Password") }}</span>
    </div>

    <div class="w-1/2 padding-r mt-6">
      <label for="" class="vs-input--label">Phone number*</label>

      <vue-tel-input @input="checkNumber" name="phone" class="w-full phone_field" v-model="phone"></vue-tel-input>

      <span class="text-danger text-sm" v-show="errors.has('phone')">{{
        errors.first("phone")
      }}</span>
    </div>

    <div class="w-1/2  mt-6 padding-l pass_block">
      <vs-input type="password" @input="checkConfirmPassword(confirmPassword)" name="confirmPassword"
        label="Confirm Password*" placeholder="Confirm Password" v-model="confirmPassword"
        class="w-full reg_pass_inp" />
      <span class="text-danger text-sm" v-show="errors.has('confirmPassword')">{{
        errors.first("confirmPassword")
      }}</span>
    </div>
    <vs-input data-vv-validate-on="change" name="company_name" type="company_name" label="Company Name*"
      placeholder="Company Name*" v-model="company_name" class="w-full mt-6" />
    <span class="text-danger text-sm">{{ errors.first("company_name") }}</span>
    <vs-textarea class="w-full message_textarea" rows="5" label="Optional message" v-model="message" />
    <div class="flex items-center w-full">
      <vs-checkbox v-model="isTermsConditionAccepted"> </vs-checkbox><a download :href="getPdf('terms')" target="_blank"
        class="cursor-pointer">I accept the terms & conditions*</a>
      <vs-checkbox v-model="isPrivacyPolicyAccepted" class="ml-10"></vs-checkbox><a download :href="getPdf('policy')"
        target="_blank" class="cursor-pointer ">I accept Privacy and Policy*</a>


    </div>

    <div class="vx-row w-full reg_buttons mb-3">
      <div class="vx-col">
        <vs-button class="float-right mt-6 unimacs_button" @click="registerUserJWt"
          :disabled="!validateForm">Submit</vs-button>
      </div>
      <div class="vx-col">
        <vs-button class="float-right mt-6 unimacs_cancel_button" @click="$router.push('/login')">Cancel</vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";

export default {
  data() {
    return {
      first_name: null,
      last_name: null,
      email: null,
      password: null,
      confirm_password: null,
      isTermsConditionAccepted: false,
      isPrivacyPolicyAccepted: false,
      phone: null,
      company_name: null,
      message: null,
      popupActive: false,
      password: null,
      confirmPassword: null,
      accountID: ""
    };
  },
  components: {
    vSelect,
  },
  computed: {
    validateForm() {
      return (
        !this.errors.any() &&
        this.company_name &&
        this.phone &&
        this.last_name &&
        this.first_name &&
        this.email &&
        this.password &&
        this.confirmPassword && this.password === this.confirmPassword &&
        this.isTermsConditionAccepted == true &&
        this.isPrivacyPolicyAccepted == true
      );
    },
    getPdf() {
      return (type) => {
        if (type == 'terms') {
          return `${process.env.VUE_APP_BACK}/Terms/terms.pdf`
        } else if (type == 'policy') {
          return `${process.env.VUE_APP_BACK}/Privacy/Privacy.pdf`

        }
      }
    },
    testMin() {
      if (String(this.password).length < 7) {
        return true
      }
    },
    testNum() {
      if (!/\d/.test(this.password)) {
        return true
      }
    },
    testUpper() {
      if (!/[A-Z]/.test(this.password)) {
        return true
      }
    },
    lowerCase() {
      if (!/[a-z]/.test(this.password)) {
        return true
      }
    }
  },

  methods: {
    handleLinkClick() {
      this.popupActive = false;

      this.$nextTick(() => {
        this.$router.push("/login");
      });
    },
    checkNumber(number, obj) {
      if (this.phone) {
        if (!obj.valid || !this.phone) {
          this.errors.add({
            field: "phone",
            msg: "Phone number not valid",
          });
        } else {
          const filter = this.errors.items.filter((e) => e.field == "phone");
          filter.forEach((f) =>
            this.errors.items.splice(
              this.errors.items.findIndex((e) => e.field === f.field),
              1
            )
          );
        }
      }
    },

    registerUserJWt() {
      const payload = {
        company: {
          company_name: this.company_name,
          // package_type: this.packet_type,
          message: this.message,
        },
        account: {
          password: this.password,
          first_name: this.first_name,
          last_name: this.last_name,
          email: this.email,
          phone_1: this.phone,
          // post_code: this.postal_code,
          avatar: null,
          phone_2: null,
          // country: this.country,
          site: null,
          address: null,
          viber: false,
          whatsapp: false,
        },
      };

      this.$http
        .post(`registration/${this.$route.params.token}`, payload)
        .then((res) => {
          this.$vs.loading.close();

          this.popupActive = true;
        })
        .catch((err) => {
          this.$vs.loading.close();

          this.activeLoading = false;
          this.popupActive = false;
        });
    },
    checkConfirmPassword(string) {
      this.$validator.errors.remove('confirmPassword', null);
      if (this.password !== this.confirmPassword) {
        this.errors.add({
          field: "confirmPassword",
          msg: "Confirm Password is wrong !!!",
        });
      }
      return false;
    },
    checkPassword(string) {
      this.$validator.errors.remove('password', null);
      // this.errors.clear();
      if (
        /\d/.test(string) &&
        /[A-Z]/.test(string) &&
        /[a-z]/.test(string)
        // &&        /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(string)
      ) {
        this.$validator.errors.remove('Password', null);
        return true;
      } else if (string.length == 0) {
        this.errors.add({
          field: "Password",
          msg: "Password field required",
        });
      } else if (string.length < 7) {
        this.errors.add({
          field: "Password",
          msg: "Password field must have min 7 character",
        });
      } else if (!/\d/.test(string)) {
        this.errors.add({
          field: "Password",
          msg: "Password field must have number",
        });
      } else if (!/[A-Z]/.test(string)) {
        this.errors.add({
          field: "Password",
          msg: "Password field must have upper case letter",
        });
      } else if (!/[a-z]/.test(string)) {
        this.errors.add({
          field: "Password",
          msg: "Password field must have lower case letter",
        });
      }

      return false;
    },
    sendMailAgain() {
      const payloadEmail = {
        email: this.email,
      };

      this.$http
        .put(`registration/${this.$route.params.token}`, payloadEmail)
        .then((res) => {
          this.$vs.notify({
            time: 7000,
            color: "success",
            title: "Invite link sent",
          });
          this.activeLoading = false;
          this.popupActive = false;
          //  this.$router.push("/error-500").catch(() => {});
        })
        .catch((err) => {
          this.$vs.loading.close();

          this.activeLoading = false;
          this.popupActive = false;
        });
    },
    getData() {
      this.$http
        .get(`registration/${this.$route.params.token}`)
        .then((res) => {
          this.$vs.loading.close();
          this.first_name = res.data.first_name || "";
          this.last_name = res.data.last_name || "";
          this.email = res.data.email || "";
          this.company_name = res.data.company_name || "";
        })
        .catch((err) => {
          this.$vs.loading.close();
        });
    }
  },
  created() {

    this.getData()
  },
  destroyed() {
    this.activeLoading = false;
    this.popupActive = false;
  },
};
</script>


<style lang="scss">
.link-text {
  border: none;
  background-color: inherit;
  color: #7367f0;
  margin-left: 4px;
  margin-right: 4px;
  cursor: pointer;
}

.pass_block {
  position: relative;
}

.pass_strength {
  width: 230px;
  position: absolute;
  right: -250px;
  bottom: -145px;
  z-index: 9999999999;
  border: 1px solid black;
  padding: 16px;
  background: white;

  &:before {
    content: '';
    display: block;
    position: absolute;
    left: -10px;
    top: 10px;
    width: 10px;
    height: 14px;
    border-style: solid;
    border-width: 7px 10px 7px 0;
    border-color: transparent black;
    box-sizing: border-box;
  }

  &:after {
    content: '';
    display: block;
    position: absolute;
    left: -9px;
    top: 11px;
    width: 10px;
    height: 12px;
    border-style: solid;
    border-width: 6px 10px 6px 0;
    border-color: transparent white;
    z-index: 1;
    box-sizing: border-box;
  }
}

.reqments {
  font-size: 13px;
  font-weight: bold;
  line-height: 1.3;
  padding-bottom: 10px;
}

.req_list {
  ul li {
    font-size: 14px;
    display: flex;
    align-items: center;

    &:before {
      content: '';
      width: 10px;
      height: 10px;
      background-color: red;
      border-radius: 50%;
      display: block;
      margin-right: 5px;
    }

    &.success {
      &:before {
        background-color: green;
        border: none;
      }
    }

    &.danger {
      &:before {
        border: none;
      }
    }
  }
}

.phone_field {
  padding: 2px 0;
}

.choose_type {
  display: flex;
  align-items: center;
}

.reg_buttons {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.register_page {
  display: flex;
  flex-wrap: wrap;
}

.register_page .vs-popup--title h3 {
  font-weight: bold;
  transform: none;
}

.register_popup .vs-popup--header i {
  background: transparent;
}

.register_popup .vs-popup--header i:hover {
  color: #7367f0;
}

.send_again button {
  padding: 0.6rem 2rem !important;
}

.vs-popup--content {
  padding: 2rem !important;
  text-align: center;

  h2 {
    font-size: 14px !important;
  }
}

.message_textarea {
  margin-top: 20px;
}

.padding-r {
  padding-right: 10px;
}

.padding-l {
  padding-left: 10px;
}

.register_text {
  margin: 13px 0;
  color: #666666;
  line-height: 1.2em;
}

.number_input {
  border-radius: 5px;
  color: inherit;
  position: relative;
  padding: 0.6rem;
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.15);
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.15);
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  width: 100%;
}

.send_again {
  margin-top: 15px;

  button {
    margin-left: 10px;
  }
}

.pass_strength {
  display: none
}

.reg_pass_inp.isFocus+.pass_strength {
  display: block
}
</style>